import { useEffect } from "react";

import { useTickSize } from "#/store/perps/page/tickSize";

import { useWorker } from "../useWorker";

export const useTrackTickSize = () => {
  const { worker, isWorkerReady } = useWorker();
  const { tickSize } = useTickSize();

  useEffect(() => {
    if (!isWorkerReady) return;

    worker!.setValues({ tickSize });
  }, [tickSize, worker, isWorkerReady]);
};
